import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-edit-modal",
  templateUrl: "./edit-modal.component.html",
  styleUrls: ["./edit-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EditModalComponent implements OnInit {
  @ViewChild("title") title;
  header_title = "To Change Title";
  error_msg = "Please enter a valid name";
  placeholder = "Name";
  subTitle;
  enableButton = true;
  showError = false;
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.subTitle = this.data.name;
  }

  onClickCancel() {
    this.data.onCancel();
  }

  onClickSubmit() {
    //Checking for white spaces
    if (this.subTitle.trim().length != "0") {
      this.data.onSuccess(this.subTitle);
    } else if (this.subTitle.trim().length == "0") {
      this.enableButton = false;
      this.showError = true;
      this.subTitle = "";
      this.title.nativeElement.focus();
    }
  }
}
